const parseDomain = require('parse-domain');
const dataCentersData = require('./data/dataCenters.json');

/**
 * @constant
 * @private
 */
const US_DATA_CENTER_ID = dataCentersData.dataCenters['0'].id;
/**
 * @constant
 * @private
 */
const CA_DATA_CENTER_ID = dataCentersData.dataCenters['1'].id;
/**
 * @constant
 * @private
 */
const EU_DATA_CENTER_ID = dataCentersData.dataCenters['2'].id; // eslint-disable-line

/**
 * Returns the data center by id
 * @param {string} dataCenterId
 * @returns {Object} data center details
 * @memberof module:@sm/locale
 */
function getDataCenterById(dataCenterId) {
  return dataCentersData.dataCenters[dataCenterId];
}

/**
 * Returns the data center id from the url
 * @param {string} url
 * @param {string} dataCenterAffinityCookie
 * @returns {string} data center id
 * @memberof module:@sm/locale
 */
function getDataCenterIdFromCurrentUrl(url, dataCenterAffinityCookie) {
  const { subdomain } = parseDomain(url) || {};

  let dataCenterId = US_DATA_CENTER_ID;
  if (subdomain) {
    const dcSub = Object.keys(
      dataCentersData.dataCenterSpecificSubdomains
    ).find(
      subSpecific =>
        subSpecific === subdomain || subdomain.endsWith(`.${subSpecific}`)
    );
    if (dcSub) {
      dataCenterId = dataCentersData.dataCenterSpecificSubdomains[dcSub];
    }
  }

  if (
    dataCenterId === US_DATA_CENTER_ID &&
    `${dataCenterAffinityCookie}` === CA_DATA_CENTER_ID
  ) {
    dataCenterId = CA_DATA_CENTER_ID;
  }

  return dataCenterId;
}

// This is currently being used in UserWeb here https://code.corp.surveymonkey.com/devmonkeys/userweb/blob/e7646369dfae9fef0c8d1fa3c23f1bde61a9c906/userweb/lib/language.py#L31
// So I'm leaving this function for when we port the corresponding code in UserWeb.
/**
 * Returns the default subdomain for a data center
 * @param {string} dataCenterId
 * @returns {string} subdomain
 * @memberof module:@sm/locale
 */
function getDefaultSubdomainForDataCenter(dataCenterId) {
  const dc = getDataCenterById(dataCenterId);
  return (dc && dc.defaultSubdomain) || 'www';
}

module.exports = {
  getDataCenterById,
  getDataCenterIdFromCurrentUrl,
  getDefaultSubdomainForDataCenter,
  US_DATA_CENTER_ID,
  CA_DATA_CENTER_ID,
  EU_DATA_CENTER_ID
};
